import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DocentScheduleHashService {
  private readonly url = environment.apiUrl + '/timetable/docent-hash';

  constructor(private readonly httpClient: HttpClient) {}

  getHash(docentName: string): Observable<{ hash: string | null }> {
    const params = new HttpParams().set('docentName', docentName);
    return this.httpClient.get<{ hash: string | null }>(this.url, { params });
  }
}
